export default "__VITE_ASSET__471e90fb__"